const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUatp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "card_cardbleue",
    transform: "matrix(0.5,0,0,0.5,0,10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-11",
    d: "M120,8C120,3.585 116.415,0 112,0L8,0C3.585,0 0,3.585 0,8L0,72C0,76.415 3.585,80 8,80L112,80C116.415,80 120,76.415 120,72L120,8Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(1,0,0,1,14,20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M24.04,18.729L48.166,18.729C47.951,13.974 46.736,9.071 43.051,5.921C38.661,2.169 30.972,0.778 24.101,0.778C16.95,0.778 9.042,2.304 4.629,6.329C0.824,9.797 0.001,15.376 0.001,20.388C0.001,25.639 1.611,31.746 5.739,35.266C10.128,39.007 17.242,40.001 24.101,40.001C30.765,40.001 37.984,38.879 42.348,35.325C46.7,31.776 48.204,25.797 48.204,20.388L48.204,20.363L24.04,20.363L24.04,18.729Z",
    style: {
      fill: "rgb(254,254,254)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M49.709,20.397L49.709,39.223L83.231,39.223L83.231,39.198C88.137,38.953 92.039,34.901 92.039,29.925C92.039,24.948 88.137,20.636 83.231,20.388L83.231,20.397L49.709,20.397Z",
    style: {
      fill: "rgb(254,254,254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M91.456,10.197C91.456,5.396 87.659,1.592 82.874,1.592C82.543,1.592 82.136,1.528 81.816,1.564L49.709,1.564L49.709,18.835L83.532,18.835C87.969,18.452 91.456,14.741 91.456,10.197",
    style: {
      fill: "rgb(254,254,254)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "card_uatp",
    transform: "matrix(0.5,0,0,0.5,0,10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-111",
    serifId: "Rectangle-11",
    d: "M120,8C120,3.585 116.415,0 112,0L8,0C3.585,0 0,3.585 0,8L0,72C0,76.415 3.585,80 8,80L112,80C116.415,80 120,76.415 120,72L120,8Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "matrix(1.05517,0,0,1.08854,6.10224,23.6505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    serifId: "Fill-1",
    d: "M0.252,3.846L0.252,20.769C0.252,20.769 0.105,24.145 2.498,26.795C4.89,29.444 9.161,30 11.806,29.915C14.45,29.829 19.644,29.274 21.659,28.547L21.659,3.846L15.111,3.846L15.111,24.103C15.111,24.103 12.068,24.915 9.885,24.402C7.702,23.889 6.548,22.094 6.548,19.658L6.548,3.846L0.252,3.846",
    style: {
      fill: "rgb(5,44,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M24.409,29.744L34.336,3.846L42.059,3.846L45.753,13.739L45.081,16.101L40.506,16.854L38.113,10.307L31.188,29.744L24.409,29.744",
    style: {
      fill: "rgb(5,44,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M41.975,21.154L44.83,29.487L51.798,29.444L47.726,18.675C47.726,18.675 46.12,19.487 44.735,20.096C43.123,20.805 41.975,21.154 41.975,21.154",
    style: {
      fill: "rgb(5,44,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    serifId: "Fill-4",
    d: "M52.133,3.846L52.133,9.487L59.689,9.487L59.689,29.744L65.985,29.744L65.985,9.487L73.541,9.487L73.541,3.846L52.133,3.846",
    style: {
      fill: "rgb(5,44,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M79.081,3.846L79.081,29.744L85.378,29.744L85.378,22.051C85.378,22.051 89.171,22.179 91.28,21.618C93.39,21.058 98.144,19.151 98.144,12.772C98.144,6.394 94.083,3.67 88.463,3.269C85.393,3.077 79.081,3.846 79.081,3.846ZM85.378,9.231L85.378,16.41C85.378,16.41 88.478,17.012 90.478,15.598C91.989,14.53 91.748,12.436 91.601,11.795C91.454,11.154 90.903,9.872 89.622,9.402C87.821,8.74 85.378,9.231 85.378,9.231Z",
    style: {
      fill: "rgb(5,44,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M26.822,23.429L27.357,22.019C27.357,22.019 24.272,22.965 22.557,23.309C22.541,23.718 22.541,23.814 22.541,23.814C22.541,23.814 23.658,23.734 24.729,23.638C25.799,23.542 26.822,23.429 26.822,23.429",
    style: {
      fill: "rgb(67,183,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M34.771,19.631C34.771,19.631 39.006,18.462 52.133,9.487L59.689,9.487L59.668,10.556C59.668,10.556 46.183,19.84 33.906,22.147C34.645,19.984 34.771,19.631 34.771,19.631",
    style: {
      fill: "rgb(67,183,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M73.499,3.846C73.499,3.846 75.556,2.788 80.813,2.051C85.162,1.442 91.58,2.308 91.58,2.308L91.611,1.827C87.959,0.705 82.261,0.192 80.561,0.128C78.861,0.064 74.454,0.256 70.739,0.833C67.024,1.41 61.431,3.846 61.431,3.846L73.499,3.846",
    style: {
      fill: "rgb(67,183,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M97.427,4.051L97.423,4.451L98.136,4.455L98.14,6.456L98.604,6.449L98.612,4.453L99.304,4.439L99.3,4.058L97.427,4.051",
    style: {
      fill: "rgb(5,44,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-111",
    serifId: "Fill-11",
    d: "M99.592,4.058L99.596,6.462L100.029,6.454L100.024,4.583L100.532,6.446L100.943,6.438L101.461,4.535L101.484,6.458L101.91,6.45L101.902,4.043L101.229,4.046L100.76,5.733L100.292,4.043L99.592,4.058",
    style: {
      fill: "rgb(5,44,24)"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.898e-15,79.9904,-79.9904,4.898e-15,60,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40,58,126)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "rgb(71,144,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "rgb(71,144,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(51,117,87)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(51,117,87)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUatp);
export default __webpack_public_path__ + "static/media/uatp.58ca9421dfd113ad3c3a507de12ef195.svg";
export { ForwardRef as ReactComponent };